import { Title, Text, Loader, Stack, Box } from "@mantine/core";
import { SignedIn, useUser } from "@clerk/clerk-react";
import { usePatronStatus } from "@/api/fapinstructor/patreon/get-patreon-status";
import { Navigate } from "@tanstack/react-router";
import { useCountdown } from "@/hooks/use-countdown";
import {
  type ClerkUser,
  createScrolllerPricingPageUrl,
} from "@/api/scrolller/utils/create-scrolller-pricing-page-url";
import { createFileRoute } from "@tanstack/react-router";
import { Page } from "@/components/page";

export const Route = createFileRoute("/_landing/pricing/")({
  component: PricingRouteComponent,
});

function PricingRouteComponent() {
  return (
    <Page title="Redirect to Pricing Page">
      <PricingPageContentDirect />
      {/* <PricingPageContent /> */}
    </Page>
  );
}

type RedirectToPaymentPageProps = { user: ClerkUser };

function RedirectToPaymentPage({ user }: RedirectToPaymentPageProps) {
  const { remainingTime } = useCountdown(
    () => {
      const scrolllerPricingPageUrl = createScrolllerPricingPageUrl(user);
      window.location.replace(scrolllerPricingPageUrl);
    },
    5,
    false,
  );

  return (
    <Text ta="center">
      Redirecting you to our pricing page in{" "}
      <Text fw="bolder">{remainingTime} seconds.</Text>
    </Text>
  );
}

function PricingPageContentDirect() {
  const patronStatusQuery = usePatronStatus();
  const isSubscribed = Boolean(patronStatusQuery.data?.subscribed);
  const { isLoaded, isSignedIn, user } = useUser();

  if (patronStatusQuery.isLoading || !isLoaded) {
    return <Loader type="dots" />;
  }

  if (!isSignedIn) {
    return <Navigate replace to="/sign-up/$" />;
  }

  if (isSubscribed) {
    return <Navigate replace to="/home" />;
  }

  return (
    <Box m="xl">
      <Stack gap="xl">
        <Box>
          <Title ta="center">Redirecting...</Title>
        </Box>
        <SignedIn>
          {user && !isSubscribed ? <RedirectToPaymentPage user={user} /> : null}
        </SignedIn>
      </Stack>
    </Box>
  );
}

// function PricingPageContent() {
//   const productId = useProductId();
//   const scrolllerProductsQuery = useScrolllerProducts();
//   const patronStatusQuery = usePatronStatus();
//   const isSubscribed = Boolean(patronStatusQuery.data?.subscribed);
//
//   if (isSubscribed) {
//     return <Navigate replace to="/subscription" />;
//   }
//
//   if (!scrolllerProductsQuery.data) {
//     return <Loader type="dots" />;
//   }
//
//   const products = scrolllerProductsQuery.data.sort(
//     (a, b) => a.price.amount - b.price.amount,
//   );
//
//   if (productId) {
//     const selectedProduct = products.find(
//       (product) => product.id === productId,
//     );
//     if (!selectedProduct) {
//       return;
//     }
//     window.location.replace(selectedProduct.checkout_url);
//     return <Loader type="dots" />;
//   }
//
//   return (
//     <Box m="xl">
//       <Stack gap="xl">
//         <Box>
//           <Title ta="center">Plans and Pricing</Title>
//           <Text ta="center" size="xl">
//             Join the best jerk-off experience on the internet.
//           </Text>
//         </Box>
//         <SignedIn>
//           <Text ta="center">
//             It looks like you aren't currently subscribed. Please select an
//             option below to gain full access to the site.
//           </Text>
//         </SignedIn>
//         <Group grow justify="center" gap="lg">
//           {products.map((product) => (
//             <ProductCard key={product.id} product={product} />
//           ))}
//         </Group>
//         <Text ta="center">
//           By continuing you agree to our{" "}
//           <Anchor to="/terms-of-service" target="_blank">
//             Terms
//           </Anchor>{" "}
//           and{" "}
//           <Anchor to="/privacy-policy" target="_blank">
//             Privacy
//           </Anchor>
//           .
//         </Text>
//         <Space h="md" />
//         <ProductPerks />
//       </Stack>
//     </Box>
//   );
// }
